
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/[brand]/[model]/price/[city]",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/[brand]/[model]/price/[city].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/[brand]/[model]/price/[city]"])
      });
    }
  